import type { IApplyingFinancingOfferRequestBody } from '@/logic/financing/interfaces'

export const isApplyingOfferRequestBody = (body: unknown): body is IApplyingFinancingOfferRequestBody => {
  return Boolean((body as IApplyingFinancingOfferRequestBody)?.loanAmount)
}
